import {
    STROLLER_BACK_SUPPORT_POSITIONING_BUCKLE,
    STROLLER_BACK_SUPPORT_POSITIONING_BUTTON,
    STROLLER_BACK_SUPPORT_POSITIONING_FRONT_RECLINE,
    STROLLER_BACK_SUPPORT_POSITIONING_REAR_RECLINE,
    STROLLER_BACK_SUPPORT_POSITIONING_SIDE_HANDLES,
    STROLLER_BACK_SUPPORT_POSITIONING_SIDE_RECLINE,
    STROLLER_BACK_SUPPORT_POSITIONING_STRAP,
    STROLLER_BACK_SUPPORT_POSITIONING_ZIP,
    STROLLER_BUMPER_BAR_TYPE_BAR,
    STROLLER_BUMPER_BAR_TYPE_T_SHAPED,
    STROLLER_BUMPER_BAR_TYPE_TRAY,
    STROLLER_CENTRAL_BRAKE_SYSTEM_HAND_OPERATED,
    STROLLER_CENTRAL_BRAKE_SYSTEM_ONE_STEP_CRADLE_BRAKE,
    STROLLER_CENTRAL_BRAKE_SYSTEM_PUSH_LIFT,
    STROLLER_CENTRAL_BRAKE_SYSTEM_PUSH_PUSH,
    STROLLER_FOLDING_SYSTEM_3D,
    STROLLER_FOLDING_SYSTEM_FLAT,
    STROLLER_FOLDING_SYSTEM_TELESCOPIC,
    STROLLER_FOLDING_SYSTEM_UMBRELLA,
    STROLLER_HANDLE_ADJUSTMENT_PIVOTING,
    STROLLER_HANDLE_ADJUSTMENT_TELESCOPIC,
    STROLLER_MATERIAL_ALUMINIUM,
    STROLLER_MATERIAL_CARBON,
    STROLLER_MATERIAL_DURAL,
    STROLLER_MATERIAL_FABRIC,
    STROLLER_MATERIAL_FOAM,
    STROLLER_MATERIAL_HARD_RUBBER,
    STROLLER_MATERIAL_IRON,
    STROLLER_MATERIAL_LEATHER,
    STROLLER_MATERIAL_LEATHERETTE,
    STROLLER_MATERIAL_MAGNESIUM,
    STROLLER_MATERIAL_METAL,
    STROLLER_MATERIAL_PLASTIC,
    STROLLER_MATERIAL_RECYCLED_PLASTIC,
    STROLLER_MATERIAL_RESIN,
    STROLLER_MATERIAL_RUBBER,
    STROLLER_MATERIAL_SILICON,
    STROLLER_MATERIAL_STEEL,
    STROLLER_MATERIAL_WOOD,
    STROLLER_OR_CONJUNCTION,
    STROLLER_SUSPENSION_ELASTOMERS,
    STROLLER_SUSPENSION_FRAME,
    STROLLER_SUSPENSION_MECHANICAL,
    STROLLER_SUSPENSION_PNEUMATIC,
    STROLLER_SUSPENSION_ROCKER,
    STROLLER_SUSPENSION_SPRING,
    STROLLER_SUSPENSION_STRAPS,
    STROLLER_TYPE_2KOMBI,
    STROLLER_TYPE_3KOMBI,
    STROLLER_TYPE_DEEP,
    STROLLER_TYPE_GOLF,
    STROLLER_TYPE_MULTIKOMBI,
    STROLLER_TYPE_PLATFORM,
    STROLLER_TYPE_SIBLINGS,
    STROLLER_TYPE_SIBLINGS_DOUBLE,
    STROLLER_TYPE_SIBLINGS_TANDEM,
    STROLLER_TYPE_SIBLINGS_TRIPLE,
    STROLLER_TYPE_SPORTY,
    STROLLER_TYPE_TRAVEL_SYSTEM,
    STROLLER_WHEEL_TYPE_AIR_WHEELS,
    STROLLER_WHEEL_TYPE_ARTIFICIAL_WHEELS,
    STROLLER_WHEEL_TYPE_FOAM_WHEELS,
    STROLLER_WHEEL_TYPE_GEL_WHEELS,
    STROLLER_WHEELS_ALL,
    STROLLER_WHEELS_FRONT,
    STROLLER_WHEELS_REAR,
} from 'mk/autogenerated/translations/options.1c5342190ad26335d947e2b8c262d528'
import { Feature, FeatureOptions } from 'mk2/apps/strollers/features/basic';
import { Features } from 'mk2/apps/strollers/schemas';
import { niceNumber } from 'mk2/apps/strollers/utils';

export interface Options {
    [K: string]: string;
}

abstract class OptionFeature extends Feature {
    public abstract OPTIONS: Options;

    public hasWorthyValue(features: Features): boolean {
        if (!features) {
            return false;
        }
        const value = features[this.featureName];
        if (!value) {
            return false;
        }
        return !!(this.OPTIONS[value]);
    }

    public niceValue(features: Features): string {
        if (!features) {
            return '';
        }
        const value = features[this.featureName];
        if (!value) {
            return '';
        }
        return this.OPTIONS[value];
    }
}

export abstract class ListFeature extends Feature {
    public abstract OPTIONS: Options;

    public hasWorthyValue(features: Features): boolean {
        if (!features) {
            return false;
        }
        const arrValue = features[this.featureName];
        if (!arrValue) {
            return false;
        }
        return (arrValue.length > 0);
    }

    public orderBeforeTrans(untranslatedArr: string[]): string[] {
        // default: NO OP
        return untranslatedArr;
    }

    public orderAfterTrans(translatedArr: string[]): string[] {
        // default: alphanumeric sort of translated values
        return [ ...translatedArr ].sort();
    }

    public decodeItem(item: string | number): string {
        return this.OPTIONS[item];
    }

    public format(itemsArr: string[] | number[]): string {
        return itemsArr.join(', ');
    }

    public niceValue(features: Features): string {
        if (!features) {
            return '';
        }
        const arrValue = features[this.featureName];
        if (!arrValue) {
            return '';
        }

        const untranslated = this.orderBeforeTrans(arrValue);
        const translated = untranslated.map((item) => this.decodeItem(item));
        const sorted = this.orderAfterTrans(translated);
        return this.format(sorted);
    }
}

abstract class OrListFeature extends ListFeature {

    public orderAfterTrans(translatedArr: string[]): string[] {
        // default: NO OP
        return translatedArr;
    }

    public format(itemsArr: string[] | number[]): string {
        return itemsArr.join(STROLLER_OR_CONJUNCTION);
    }
}

export class OrNumericListFeature extends OrListFeature {
    public OPTIONS: Options;

    public getDefaultOptions(): FeatureOptions {
        return { nice: true };
    }

    public decodeItem(item: number): string {
        return this.options.nice ? niceNumber(item) : `${item}`;
    }
}

export class ArtificialWheelTypeFeature extends ListFeature {
    public OPTIONS = {
        'foam': STROLLER_MATERIAL_FOAM,
        'hard rubber': STROLLER_MATERIAL_HARD_RUBBER,
        'plastic': STROLLER_MATERIAL_PLASTIC,
        'resin': STROLLER_MATERIAL_RESIN,
        'silicon': STROLLER_MATERIAL_SILICON,
    };
}

export class WheelTypeFeature extends OrListFeature {
    public OPTIONS = {
        'air wheels': STROLLER_WHEEL_TYPE_AIR_WHEELS,
        'artificial wheels': STROLLER_WHEEL_TYPE_ARTIFICIAL_WHEELS,
        'foam wheels': STROLLER_WHEEL_TYPE_FOAM_WHEELS,
        'gel wheels': STROLLER_WHEEL_TYPE_GEL_WHEELS,
    };
}

export class BackSupportPositioningTypeFeature extends ListFeature {
    public OPTIONS = {
        'buckle': STROLLER_BACK_SUPPORT_POSITIONING_BUCKLE,
        'button': STROLLER_BACK_SUPPORT_POSITIONING_BUTTON,
        'front recline': STROLLER_BACK_SUPPORT_POSITIONING_FRONT_RECLINE,
        'rear recline': STROLLER_BACK_SUPPORT_POSITIONING_REAR_RECLINE,
        'side handles': STROLLER_BACK_SUPPORT_POSITIONING_SIDE_HANDLES,
        'side recline': STROLLER_BACK_SUPPORT_POSITIONING_SIDE_RECLINE,
        'strap': STROLLER_BACK_SUPPORT_POSITIONING_STRAP,
        'zip': STROLLER_BACK_SUPPORT_POSITIONING_ZIP,
    };
}

export class CentralBrakeSystemFeature extends ListFeature {
    public OPTIONS = {
        'hand-operated': STROLLER_CENTRAL_BRAKE_SYSTEM_HAND_OPERATED,
        'one-step cradle brake': STROLLER_CENTRAL_BRAKE_SYSTEM_ONE_STEP_CRADLE_BRAKE,
        'push-lift pedal brake': STROLLER_CENTRAL_BRAKE_SYSTEM_PUSH_LIFT,
        'push-push pedal brake': STROLLER_CENTRAL_BRAKE_SYSTEM_PUSH_PUSH,
    };
}

export class FoldingSystemFeature extends ListFeature {
    public OPTIONS = {
        '3D': STROLLER_FOLDING_SYSTEM_3D,
        'flat': STROLLER_FOLDING_SYSTEM_FLAT,
        'telescopic': STROLLER_FOLDING_SYSTEM_TELESCOPIC,
        'umbrella': STROLLER_FOLDING_SYSTEM_UMBRELLA,
    };
}

export class MaterialFeature extends ListFeature {
    public OPTIONS = {
        'aluminium': STROLLER_MATERIAL_ALUMINIUM,
        'carbon': STROLLER_MATERIAL_CARBON,
        'dural': STROLLER_MATERIAL_DURAL,
        'fabric': STROLLER_MATERIAL_FABRIC,
        'foam': STROLLER_MATERIAL_FOAM,
        'hard rubber': STROLLER_MATERIAL_HARD_RUBBER,
        'iron': STROLLER_MATERIAL_IRON,
        'leather': STROLLER_MATERIAL_LEATHER,
        'leatherette': STROLLER_MATERIAL_LEATHERETTE,
        'magnesium': STROLLER_MATERIAL_MAGNESIUM,
        'metal': STROLLER_MATERIAL_METAL,
        'plastic': STROLLER_MATERIAL_PLASTIC,
        'recycled plastic': STROLLER_MATERIAL_RECYCLED_PLASTIC,
        'rubber': STROLLER_MATERIAL_RUBBER,
        'steel': STROLLER_MATERIAL_STEEL,
        'wood': STROLLER_MATERIAL_WOOD,
    };
}

export class BumperBarTypeFeature extends ListFeature {
    public OPTIONS = {
        'bar': STROLLER_BUMPER_BAR_TYPE_BAR,
        'T shaped': STROLLER_BUMPER_BAR_TYPE_T_SHAPED,
        'tray': STROLLER_BUMPER_BAR_TYPE_TRAY,
    };
}

export class SuspendedWheelsFeature extends OptionFeature {
    public OPTIONS = {
        all: STROLLER_WHEELS_ALL,
        front: STROLLER_WHEELS_FRONT,
        rear: STROLLER_WHEELS_REAR,
    };
}

export class SuspensionTypeFeature extends ListFeature {
    public OPTIONS = {
        elastomers: STROLLER_SUSPENSION_ELASTOMERS,
        frame: STROLLER_SUSPENSION_FRAME,
        mechanical: STROLLER_SUSPENSION_MECHANICAL,
        pneumatic: STROLLER_SUSPENSION_PNEUMATIC,
        rocker: STROLLER_SUSPENSION_ROCKER,
        spring: STROLLER_SUSPENSION_SPRING,
        straps: STROLLER_SUSPENSION_STRAPS,
    };
}

export class HandleAdjustmentTypeFeature extends ListFeature {
    public OPTIONS = {
        pivoting: STROLLER_HANDLE_ADJUSTMENT_PIVOTING,
        telescopic: STROLLER_HANDLE_ADJUSTMENT_TELESCOPIC,
    };
}

export class TypeFeature extends ListFeature {
    public OPTIONS = {
        '2kombi': STROLLER_TYPE_2KOMBI,
        '3kombi': STROLLER_TYPE_3KOMBI,
        'golf': STROLLER_TYPE_GOLF,
        'deep': STROLLER_TYPE_DEEP,
        'platform': STROLLER_TYPE_PLATFORM,
        'siblings': STROLLER_TYPE_SIBLINGS,
        'siblings (double)': STROLLER_TYPE_SIBLINGS_DOUBLE,
        'siblings (tandem)': STROLLER_TYPE_SIBLINGS_TANDEM,
        'siblings (triple)': STROLLER_TYPE_SIBLINGS_TRIPLE,
        'sporty': STROLLER_TYPE_SPORTY,
        'multikombi': STROLLER_TYPE_MULTIKOMBI,
        'travel system': STROLLER_TYPE_TRAVEL_SYSTEM,
    };

    private ORDER = [
        'deep',
        'sporty',
        'golf',
        'travel system',
        '2kombi',
        '3kombi',
        'multikombi',
        'siblings',
        'siblings (double)',
        'siblings (tandem)',
        'siblings (triple)',
        'platform',
    ];

    public orderBeforeTrans(untranslatedArr: string[]): string[] {
        return this.ORDER.filter((item) => {
            return untranslatedArr.indexOf(item) >= 0;
        });
    }

    public orderAfterTrans(translatedArr: string[]): string[] {
        return translatedArr;
    }
}
